<template>
  <div>
    <visual-hero
      image="/assets/img/visual/ucrs-visual-shop.png"
      background-color="bg-green-shop"
    >
      <template #title>Servizi immobiliari</template>
      <template #description>
        C'è un <strong>partner</strong> per ogni bisogno, gestire la
        compravendita, alleggerire la bolletta, cercare il documento che ti
        manca.
      </template>
    </visual-hero>
    <section class="container mb-16">
      <breadcrumbs :items="breadcrumbs" label="label" url="url" />

      <div class="text-center p-4 my-20">
        <p class="text-[30px] leading-[42px] mb-10">
          Sei un venditore?<br />
          Scopri i nuovi servizi immobiliari offerti dai nostri
          <strong>Partner</strong>.<br />
          Accedi o iscriviti all'
          <strong>AREA RISERVATA</strong>
        </p>
        <div
          class="block ucrs-button ucrs-button--primary cursor-pointer"
          @click.prevent="clickLogin"
        >
          Accedi o Registrati
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Static assets

// Static assets
// Components
import VisualHero from '~/components/VisualHero.vue'
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import Auth from '~/mixins/auth'

export default {
  components: {
    Breadcrumbs,
    VisualHero,
  },
  mixins: [Auth],

  data() {
    return {
      breadcrumbs: [
        {
          label: 'Home',
          url: '/',
        },
        {
          label: 'Servizi e documenti per la casa',
          url: '/servizi-documenti-casa',
        },
      ],
    }
  },

  beforeCreate() {
    if (this.$store.state.auth.loggedIn) {
      this.$router.replace({
        path: '/area-riservata/servizi-documenti-casa',
      })
    }
  },

  methods: {
    clickLogin() {
      this.openLoginPopup({
        events: {
          success: () => {
            this.$router.push('/area-riservata/dashboard')
          },
        },
      })
    },
  },
}
</script>
